import { createSelector } from "@reduxjs/toolkit";
import { useMemo } from "react";

import { getDesignerNodeDataByIdSelector } from "@skilitics/nautilus-core-designer-data";

import { getIsPlaceholderNodeSelector } from "../state/contextualSelectors/nodeSlotSelectors.ts";
import { useNautilusSelector } from "../state/shared.ts";
import { useContextPathNodeIds } from "./context.ts";

const getBreadcrumbNodeDataByIdSelector = createSelector(
  [getDesignerNodeDataByIdSelector, getIsPlaceholderNodeSelector],
  (getDesignerNodeData, getIsPlaceholder) => (nodeIds: number[]) =>
    nodeIds.filter((id) => !getIsPlaceholder(id)).map((id) => getDesignerNodeData(id)),
);

export const useGetInteractBreadcrumbNodes = () => {
  const nodeIds = useContextPathNodeIds();
  const getBreadcrumbNodeData = useNautilusSelector(getBreadcrumbNodeDataByIdSelector);

  return useMemo(() => () => getBreadcrumbNodeData(nodeIds), [getBreadcrumbNodeData, nodeIds]);
};
